<script setup>
import SpinningCoin from '@components/global/loading/SpinningCoin.vue'
</script>

<template>
	<div class="bg-size-60 pointer-events-none fixed top-0 z-50 flex h-dvh w-full touch-none select-none items-center justify-center bg-crowns-off-black bg-modal-pattern bg-right-top bg-no-repeat sm:bg-auto">
		<SpinningCoin />
	</div>
</template>
